import { SUGGESTION_CLASS } from '../store/schema/Suggestion';
import SuggestionNode from '../store/schema/SuggestionNode';
import { logSuggestionShown } from '../telemetryHelpers/logDatapoints';
import updateTelemetryForSuggestionOnSuggestionShown from '../telemetryHelpers/updateTelemetryForSuggestionOnSuggestionShown';
import { DefaultPalette } from '@uifabric/styling/lib';
import { ContentPosition, IEditor } from 'roosterjs-editor-types';
import { ISmartComposeSession } from '@qas/smartcompose-tslibrary/dist/src/session';
import { SmartComposeInteraction } from '@qas/smartcompose-tslibrary/dist/src/smartComposeInteraction';
import getShouldShowTabHint from './getShouldShowTabHint';
import { tabKeyHint } from './suggestionInEditor.locstring.json';
import { tabOutline } from 'owa-shared-post-boot';
import loc from 'owa-localize';
const SUGGESTION_TEXT_COLOR = DefaultPalette.neutralSecondary;
const SUGGESTION_TEXT_COLOR_DARK = DefaultPalette.neutralTertiary;

// Shows the current suggestion to the user by appending it in a span of grey text right
// at the current insertion point
export default function showSuggestionInEditor(
    editor: IEditor,
    suggestionString: string,
    currentSuggestionTelemetry: SmartComposeInteraction,
    charactersTypedInSession: number,
    currentSmartComposeSession: ISmartComposeSession,
    isDarkMode: boolean,
    numberOfCharactersRendered: number
): SuggestionNode {
    if (!editor) {
        return null;
    }
    // Create the span for the new suggestion:
    const span = document.createElement('span');
    span.style.whiteSpace = 'pre-wrap';

    const tabIcon = document.createElement('span');
    tabIcon.textContent = loc(tabKeyHint);
    tabIcon.style.width = '49px';
    tabIcon.style.height = '19px';
    tabIcon.style.borderRadius = '2px';
    tabIcon.style.borderStyle = 'solid';
    tabIcon.style.borderWidth = '1px';
    tabIcon.style.borderColor = SUGGESTION_TEXT_COLOR;
    tabIcon.style.whiteSpace = 'nowrap';

    tabIcon.style.fontSize = '0.7em';
    tabIcon.style.paddingLeft = '3px';
    tabIcon.style.paddingRight = '3px';
    tabIcon.style.paddingTop = '1px';
    tabIcon.style.marginLeft = '4px';
    tabIcon.style.position = 'relative';
    tabIcon.style.top = '-2px';

    span.className = SUGGESTION_CLASS;
    span.setAttribute('contenteditable', 'false');
    const suggestionTextNode = document.createTextNode(suggestionString);
    span.appendChild(suggestionTextNode);

    if (getShouldShowTabHint()) {
        span.appendChild(tabIcon);
    }

    span.style.color = isDarkMode ? SUGGESTION_TEXT_COLOR_DARK : SUGGESTION_TEXT_COLOR;

    // Add the new suggestion to the editor:
    updateTelemetryForSuggestionOnSuggestionShown(
        currentSuggestionTelemetry,
        charactersTypedInSession,
        numberOfCharactersRendered
    );
    logSuggestionShown(currentSuggestionTelemetry, currentSmartComposeSession);

    editor.addUndoSnapshot();
    editor.insertNode(span, {
        position: ContentPosition.SelectionStart,
        updateCursor: false,
        replaceSelection: true,
        insertOnNewLine: false,
    });

    tabOutline.disable = true;

    return {
        suggestionNode: span,
        suggestionTextNode: suggestionTextNode,
    };
}
